import { useProviderProfile } from "@/queries/provider/setting/use-provider-profile";
import { getXtenantId } from "@/utils/utils";

/** True while the logged-in Co-Signer (Supervising MD) has not set a Co-Sign PIN. */
export const useCosignPinRequired = (): boolean => {
  // Mirrors AccountSettings: the profile hook is typed as a list result but returns the provider.
  const { data: profile }: any = useProviderProfile(
    getXtenantId() ?? undefined
  );
  const providerData = profile?.data;

  return (
    providerData?.baseRole === "SUPERVISING_MD" &&
    !providerData?.cosignPinUpdatedAt
  );
};
